import { ThemeProvider } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { ApplicationRoutes } from "./activities";
import type { InitialRoute } from "./modules/common";
import { theme } from "./theme";

function App({ initialRoute }: Readonly<{ initialRoute?: InitialRoute }>) {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <ApplicationRoutes initialRoute={initialRoute} />
    </ThemeProvider>
  );
}

export default App;
